export default "__VITE_ASSET__C41I5zTH__"